export default __webpack_public_path__ + "static/media/LightBlue0006.9cabc76d.png";